import styled from "styled-components";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ReadMoreIcon from "@mui/icons-material/ReadMore";
import useConfirm from "common/modal/ConfirmDialog";
import { PlaySource } from "type/panel/Panel.type";

type AreaSourceSingleNavProps = {
  onDelete: Function;
  onEdit: Function;
};

const AreaSourceSingleNav = ({
  onDelete,
  onEdit,
}: AreaSourceSingleNavProps) => {
  const actionConfirm = useConfirm();

  const deleteHandle = async () => {
    const check = await actionConfirm({
      title: "Play Source",
      message: "Are you sure you want to delete play source",
    });
    if (check) {
      onDelete();
    }
  };

  return (
    <DivNav>
      <DeleteIcon onClick={deleteHandle} />
      <EditIcon onClick={() => onEdit()} />
      <ReadMoreIcon />
    </DivNav>
  );
};

const DivNav = styled.div`
  margin-top: 0.75rem;
  svg {
    margin-left: 1rem;
    cursor: pointer;
  }
  svg:hover {
    opacity: 0.8;
  }
  &&& > svg:first-of-type {
    margin-left: 0;
  }
`;

export default AreaSourceSingleNav;
